import { useRef as l, useCallback as i } from "react";
import { useDebounce as h } from "react-use";
const b = ({
  delay: s,
  field: a,
  doOnBlur: r
}) => {
  const e = l(), { onBlur: t, onChange: n } = a, [c, u] = h(
    () => {
      e.current && n(e.current);
    },
    s,
    [e.current]
  ), f = i(
    (o) => {
      o.preventDefault(), e.current && (c() || u(), r(e.current), n(e.current)), t(o);
    },
    [t, c, u, r, n]
  );
  return [e, f];
};
export {
  b as default
};
